import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {isEmpty} from 'lodash/lang';
import {FormErrors, CommonModal} from '../common';
import ReadingForm from './ReadingForm';
import {updateReading} from 'api';
import {fetchReading, clearCurrentReading} from 'actions/readings';
import {addFlashMessage} from 'actions/flash-message';
import {formatErrors} from 'actions/errors';
import {getReadingReactions} from '../../utils/common';

class ReadingUpdate extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };
  static propTypes = {
    readOnly: PropTypes.bool.isRequired,
    activeReadingReactions: PropTypes.object,
    onSubmitSuccess: PropTypes.func.isRequired,
  };
  static defaultProps = {
    readOnly: false,
  };

  constructor(props) {
    super(props);
    const {userId} = this.props;
    if (userId) {
      this.urlPrefix = `/users/${userId}/readings`;
    } else {
      this.urlPrefix = '/readings';
    }
    this.state = {
      shown: true,
      errors: {},
    };
    this.exitUpdate = this.exitUpdate.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  componentDidMount() {
    const {
      fetchReading,
      formatErrors,
      match: {
        params: {readingId},
      },
    } = this.props;
    fetchReading(readingId).catch((err) => formatErrors(err, this.urlPrefix));
  }

  componentWillUnmount() {
    this.props.clearCurrentReading();
  }

  exitUpdate() {
    const {
      router: {
        history: {push},
      },
    } = this.context;
    return new Promise((resolve) => {
      this.setState(
        {
          shown: false,
        },
        () =>
          setTimeout(() => {
            push(this.urlPrefix);
            resolve();
          }, 100),
      );
    });
  }

  handleFormSubmit(data) {
    const {
      activeReadingReactions,
      onSubmitSuccess,
      formatErrors,
      addFlashMessage,
      match: {
        params: {readingId},
      },
    } = this.props;
    const {id: commonImageId} = getReadingReactions(activeReadingReactions)[data.reaction / 2];
    return updateReading({
      readingId,
      ...data,
      book: !isNaN(data.book) ? data.book : data.book.id,
      reaction: data.reaction,
      commonImageId,
      page: !isEmpty(data.page) ? parseInt(data.page) : null,
    })
      .then(() => {
        addFlashMessage('Reading has been successfully updated!', 'success');
        this.exitUpdate().then(() => onSubmitSuccess());
      })
      .catch((err) =>
        formatErrors(err).then((err) => {
          this.setState({
            errors: err,
          });
        }),
      );
  }

  render() {
    const {shown, errors} = this.state;
    const {readOnly, activeReadingReactions, studentSetReadingPeriod} = this.props;
    if (isEmpty(activeReadingReactions)) return null;
    return (
      <CommonModal title="Edit Reading" onClose={this.exitUpdate} show={shown}>
        <FormErrors errors={errors} />
        <ReadingForm.Update
          readOnly={readOnly}
          activeReadingReactions={activeReadingReactions}
          studentSetReadingPeriod={studentSetReadingPeriod}
          onSubmit={this.handleFormSubmit}
        />
      </CommonModal>
    );
  }
}

export default connect(null, {
  formatErrors,
  addFlashMessage,
  fetchReading,
  clearCurrentReading,
})(ReadingUpdate);
